module.exports = __webpack_public_path__ + "img/javascript.2f94592a.svg";